import React, { useContext } from "react";
import styles from './style'
import { useTheme } from '@mui/styles'
import { Grid, Typography, Container , Dialog} from "@mui/material";
import { Button } from '@alquiler-argentina/aa-componentes';
import Footer from '../Footer';
import isMobile from 'ismobilejs';
import ModalCloseIcon from '../ModalCloseIcon';
import UserContext from '../ContextUser/Context';

export const SuccessUpdate = (props) => {
  const theme = useTheme()
  const classes = styles(theme);
  const tipo = props.tipo || (window.g && window.g.tipo)
  const secondaryButton = tipo == 2 || tipo == 3 
  const { state } = useContext(UserContext);

  const isApp = window.location.href.includes("app");

  const onClickContinuar = () =>{
    if(props.modalOpen){
      handleClose()
    } else {
      window.location.href= !isApp ? process.env.MIX_DOMINIO_WEB : process.env.MIX_DOMINIO_APP;
    }
  }

  const publicarAnfitrion = () => { 
    const cantUnidades = 1
    const link = process.env.MIX_DOMINIO_LEGACY + "/prepublicar.html?ref=new&e="+props.email+"&cant_unidades="+cantUnidades+(window.g.backdoorWizard ? "&backdoor_wizard=1" : "") + (window.g.id_ejecutivo ? "&id_ejecutivo="+window.g.id_ejecutivo : "");
    const linkTroya = process.env.MIX_DOMINIO_LEGACY + "/prepublicar.html?ref=new&es_troya=1&e="+props.email+(window.g.backdoorWizard ? "&backdoor_wizard=1" : "") + (window.g.id_ejecutivo ? "&id_ejecutivo="+window.g.id_ejecutivo : "");
    window.location.href = props.esTroya ? linkTroya : link;	
  } 

  const onClickIngresarPanel = () =>{
    if(state.tipo == 2 || tipo == 2){
      window.location.href= process.env.MIX_URL_CLIENTES;
    } else if(state.tipo == 3 || tipo == 3){
      window.location.href= process.env.MIX_URL_PDC;
    }
  }

  const handleClose = () =>{
    props.onCloseLoginModal()
    location.reload()
  }

  const successUpdateContainer = 
    <Container component="main" maxWidth="xs">
      {props.modalOpen && <ModalCloseIcon onClick={handleClose} />}
      <div css={classes.paper}>
        <Grid item xs={12}>
          <img
            src="/imagenes/ilustracionConfirmado.svg"
            css={classes.designerIcon}
          />
        </Grid>
        <Typography
          variant="h5"
          style={{ marginBottom: "25px" }}
          component="div"
        >
          {props.title}
        </Typography>
        <Typography
          component="div"
          align="center"
          variant="body1"
        >
          {props.subtitle}
        </Typography>
        {props.secondaryButton || secondaryButton ?
          <div>
              <Button
                  fullWidth
                  onClick={onClickIngresarPanel}
                  variant="contained"
                  color="primary"
                  css={classes.submit2}
              >
                  Ingresar al panel
              </Button>
              <Button
                  fullWidth
                  onClick={props.createAnfitrion ? publicarAnfitrion : onClickContinuar}
                  variant="outlined"
                  size="large"
                  color="primary"
                  css={classes.submit2}
              >
                  {props.createAnfitrion ? 'Cargar alojamiento' : 'Continuar al sitio'}
              </Button>
          </div>
              : 
              <Button
                fullWidth
                onClick={props.createAnfitrion ? publicarAnfitrion : onClickContinuar}
                variant="contained"
                color="primary"
                size="large"
                css={classes.submit}
                >
                  {props.createAnfitrion ? 'Cargar alojamiento' : 'Continuar al sitio'}
              </Button>
                }
      </div>
      <Footer />
    </Container>

  return (
    props.modalOpen ? (<Dialog fullScreen={isMobile.any} css={isMobile.any ? classes.modal : ''} open={props.modalOpen}>{successUpdateContainer}</Dialog>) : successUpdateContainer
    
  );
};
